import {BrowserRouter as Router, Route, Routes} from "react-router-dom";

import Layout from "./components/Layout/Layout";
import MainPage from "./pages/MainPage/MainPage";

import './App.css';
import {ConfigProvider} from "antd";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import ProductionsPage from "./pages/ProductionsPage/ProductionsPage";
import MTP1 from "./pages/ProductPages/MTP1";
import ContactsPage from "./pages/ContactsPage/ContactsPage";
import MTP2 from "./pages/ProductPages/MTP2";
import PersonalDataPage from "./pages/PersonalDataPage/PersonalDataPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import MDP1 from "./pages/ProductPages/MDP1";
import MDP2 from "./pages/ProductPages/MDP2";
import MMGP from "./pages/ProductPages/MMGP";
import ScrollToTop from "./components/ScrollToTop";
import KormovoyMel from "./pages/ProductPages/KormovoyMel";


function App() {

    const customTheme = {
        token: {
            colorPrimary: '#c5c4c4',
            colorLink: '#c5c4c4',
            colorLinkHover: '#c5c4c4',
            colorLinkActive: '#000000',
        },
    };

    return (
        <ConfigProvider theme={customTheme}>
            <Router>
                <ScrollToTop/>
              <Routes>
                <Route path="/" element={<Layout><MainPage /></Layout>} />
                <Route path="*" element={<Layout><MainPage /></Layout>} />
                <Route path="/aboutUs" element={<Layout><AboutUsPage /></Layout>} />
                <Route path="/contacts" element={<Layout><ContactsPage /></Layout>} />

                <Route path="/productions" element={<Layout><ProductionsPage /></Layout>} />
                <Route path="/MTP-1" element={<Layout><MTP1 /></Layout>} />
                <Route path="/MTP-2" element={<Layout><MTP2 /></Layout>} />
                <Route path="/MDP-1" element={<Layout><MDP1 /></Layout>} />
                <Route path="/MDP-2" element={<Layout><MDP2 /></Layout>} />
                <Route path="/MMGP" element={<Layout><MMGP /></Layout>} />
                <Route path="/kormovoyMel" element={<Layout><KormovoyMel /></Layout>} />

                <Route path="/terms" element={<Layout><PersonalDataPage /></Layout>} />
                <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
              </Routes>
            </Router>
        </ConfigProvider>
    );
}

export default App;
